"use client";

import React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "Discover",
  points: ["Browse our curated collection of premium urban residences.", "Filter by neighborhood, price range, and desired amenities.", "Save your favorite listings to your personal dashboard."]
}, {
  title: "Tour",
  points: ["Schedule a private viewing at your convenience.", "Experience the architecture and finishes in person.", "Get expert insights from our dedicated leasing agents."]
}, {
  title: "Apply",
  points: ["Complete our streamlined digital application process.", "Submit required documentation through our secure portal.", "Receive a decision within 24-48 business hours."]
}, {
  title: "Move-In",
  points: ["Finalize your lease agreement with digital signatures.", "Coordinate your arrival with our concierge team.", "Welcome home to your new Urban Living residence."]
}];
export default function SeamlessMovingProcess() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224670" id="seamless-moving-process" className="relative py-24 bg-background text-foreground overflow-hidden" ref={ref}>
      {}
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-primary/5 rounded-lg blur-[100px] -z-10 pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-primary/10 rounded-lg blur-[80px] -z-10 pointer-events-none" />

      <div className={`max-w-6xl mx-auto px-4 md:px-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
        
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-5xl font-default font-bold text-foreground mb-6 tracking-tight">
            Seamless Moving Process
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-default leading-relaxed">
            Experience a refined journey to your new home with our methodical approach to urban luxury living.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto">
          {}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-border to-transparent md:-translate-x-1/2" />

          <div className="space-y-16 md:space-y-24">
            {steps.map((step, i) => <div data-index={i} key={i} className="relative flex flex-col md:flex-row items-center gap-8">
                
                {}
                <div className="absolute left-8 md:left-1/2 -translate-x-1/2 flex items-center justify-center bg-background py-6 z-10">
                  <span className="text-6xl md:text-7xl font-default font-bold text-transparent [-webkit-text-stroke:1px_var(--color-primary)] opacity-90 select-none">
                    0{i + 1}
                  </span>
                </div>

                {}
                <div className={`w-full md:w-1/2 pl-24 md:pl-0 ${i % 2 === 0 ? 'md:pr-20' : 'md:pl-20 md:ml-auto'}`}>
                  <Card className="bg-card/80 backdrop-blur-md border-border/50 shadow-md hover:shadow-xl transition-all duration-500 relative overflow-hidden group rounded-md">
                    {}
                    <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                    
                    <CardContent className="p-6 md:p-8 relative z-10">
                      <h3 className="text-2xl font-default font-bold text-foreground mb-6">
                        {step.title}
                      </h3>
                      <ul className="space-y-4">
                        {step.points.map((point, j) => <li data-index={j} key={j} className="flex items-start gap-3">
                            <div className="mt-1 bg-primary/10 rounded-md p-1 shrink-0">
                              <Check className="w-4 h-4 text-primary" />
                            </div>
                            <span className="text-muted-foreground font-default leading-relaxed">
                              {point}
                            </span>
                          </li>)}
                      </ul>
                    </CardContent>
                  </Card>
                </div>

              </div>)}
          </div>
        </div>

        <div className="mt-24 flex justify-center">
          <Button size="lg" className="rounded-md px-8 shadow-md hover:shadow-lg transition-all bg-primary text-primary-foreground font-default font-semibold" asChild>
            <Link to="/ResidencesPage">
              Explore Residences
            </Link>
          </Button>
        </div>

      </div>
    </section>;
}